
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';

import { Injectable } from '@angular/core';

import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Subject } from 'rxjs/Rx';
import { IDtoEvent } from 'app/shared/models/incident/dto-event.model';
import { IDtoTicket } from 'app/shared/models/incident/dto-ticket.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoTicketResourceLocation } from 'app/shared/models/incident/dto-ticket-resource-location.model';
import { IDtoTicketResource } from 'app/shared/models/incident/dto-ticket-resource.model';

@Injectable()
export class IncidentService {
  private incidentUrl = '';
  private listCatalogs = new Subject<IDtoCatalog[]>();
  public object: any;
  public listCatalogsChallenge$ = this.listCatalogs.asObservable();
  constructor(private service: DataService, private configurationService: ConfigurationService) {
    if (this.configurationService.isReady) {
      this.incidentUrl = this.configurationService.serverSettings.incidentUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.incidentUrl = this.configurationService.serverSettings.incidentUrl;
      });
    }
  }
  public getCatalogResource(): Observable<IDtoTicketResource[]> {
    const url = this.incidentUrl + 'api/resource/getCatalogTicketResource';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogLocations(): Observable<IDtoCatalog[]> {
    const url = this.incidentUrl + 'api/location/getCatalogLocations';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogs() {
    return Observable.forkJoin([
      this.getCatalogResource(),
      this.getCatalogLocations(),
    ]).subscribe(([resources, locations]) => {
      const list: any[] = [];
      list.push(resources);
      list.push(locations);
      this.listCatalogs.next(list);
      //
    });
  }
  public getEventsByDate(start, end, employeeId, perfil): Observable<IDtoEvent[]> {
    const url = `${this.incidentUrl}api/event/getEventsByDate?start=${start}&end=${end}
    &employeeId=${employeeId}&perfil=${perfil}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  public getTicketsByDate(start, end, employeeId, perfilSeleccionado): Observable<IDtoTicket[]> {
    const url = `${this.incidentUrl}api/ticket/getTicketsByDate?start=${start}&end=${end}
    &employeeId=${employeeId}&perfil=${perfilSeleccionado}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  public getTickets(eventId: number): Observable<IDtoTicket[]> {
    const url = `${this.incidentUrl}api/ticket/getTickets?eventId=${eventId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public closeEvent(event): Observable<IResult> {
    const url = this.incidentUrl + 'api/event/closeEvent';
    return this.service.post(url, event).pipe(map((response: any) => {
      return response;
    }));
  }
  public addEvent(event: IDtoEvent): Observable<IResult> {
    const url = this.incidentUrl + 'api/event/addEvent/';
    return this.service.post(url, event).pipe(map((response: any) => {
      return response;
    }));
  }
  public addTicket(ticket: IDtoTicket): Observable<IResult> {
    const url = this.incidentUrl + 'api/ticket/addTicket/';
    return this.service.post(url, ticket).pipe(map((response: any) => {
      return response;
    }));
  }
  public listStatusIncident: IDtoCatalog[] = [
    { id: 1, name: 'Nuevo' }, { id: 2, name: 'Progreso' },
    { id: 3, name: 'Pendiente' }, { id: 4, name: 'Cerrado' }];

  public getEmployeesAssigned(): Observable<IResult> {
    const url = this.incidentUrl + 'api/resource/getEmployeesAssigned';
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateTicket(ticket: IDtoTicket): Observable<IResult> {
    const url = this.incidentUrl + 'api/ticket/updateTicket/';
    return this.service.putWithId(url, ticket).pipe(map((response: any) => {
      return response;
    }));
  }
  public getTicketById(ticketId: number): Observable<IDtoTicket> {
    const url = `${this.incidentUrl}api/ticket/getTicketById?ticketId=${ticketId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getEventById(eventId: number): Observable<IDtoEvent> {
    const url = `${this.incidentUrl}api/Event/getEventById?eventId=${eventId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getResourceLocation(locationId: number, ticketResourceId: number): Observable<IResult> {
    const url = `${this.incidentUrl}api/resource/getResourceLocation?locationId=${locationId}&ticketResourceId=${ticketResourceId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
